export default class SessionStorage {
  static get = (key) => {
    const data = window.sessionStorage.getItem(key);

    return data ? JSON.parse(data) : null;
  };

  static set = (key, value) => {
    const data = typeof value === 'string' ? value : JSON.stringify(value);

    window.sessionStorage.setItem(key, data);
  };

  static remove = (key) => window.sessionStorage.removeItem(key);
}
